

/* This is a AOS script */

 AOS.init({
         disable: 'mobile',
         duration: 900,
         offset: 0,
     })
 

new VenoBox({
  selector: '.my-video-links',
});

$('#maindiv').width($('#div1').width());

$('#maindiv').width($('#div3').width());







